/* ==========================================================================
   OliveDrab — wishlist

   Stored in the visitor's own browser, so it needs no app and no account.
   Cards on the wishlist page are rendered by Liquid through the card fragment
   section, which keeps prices, badges and stock accurate.

   Designed by Thriftizer.
   ========================================================================== */
(function () {
  'use strict';

  var cfg = window.ODConfig || {};
  var wish = cfg.wishlist || {};
  var strings = cfg.strings || {};
  var KEY = wish.key || 'od_wishlist';

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* -------------------------------------------------------------- store */

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var arr = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(arr)) return [];
      return arr.filter(function (x) { return x && typeof x.handle === 'string'; });
    } catch (e) { return []; }
  }

  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    broadcast(list);
  }

  function broadcast(list) {
    document.dispatchEvent(new CustomEvent('od:wishlist:changed', {
      detail: { count: list.length, items: list }
    }));
    paintCount(list.length);
    paintButtons();
  }

  function has(handle) {
    return read().some(function (x) { return x.handle === handle; });
  }

  function toggle(handle, id) {
    var list = read();
    var i = -1;
    for (var n = 0; n < list.length; n++) {
      if (list[n].handle === handle) { i = n; break; }
    }
    var added;
    if (i > -1) {
      list.splice(i, 1);
      added = false;
    } else {
      list.unshift({ handle: handle, id: id || null, at: Date.now() });
      added = true;
    }
    write(list);
    return added;
  }

  function remove(handle) {
    write(read().filter(function (x) { return x.handle !== handle; }));
  }

  /* ---------------------------------------------------------- painting */

  function paintCount(n) {
    $$('[data-od-wish-count]').forEach(function (el) {
      el.textContent = String(n);
      el.hidden = n === 0;
    });
  }

  function paintButtons(ctx) {
    var list = read();
    var set = {};
    list.forEach(function (x) { set[x.handle] = true; });

    $$('[data-od-wish]', ctx || document).forEach(function (btn) {
      var on = !!set[btn.dataset.handle];
      btn.setAttribute('aria-pressed', String(on));
    });
  }

  /* ----------------------------------------------------------- binding */

  function bind(ctx) {
    $$('[data-od-wish]', ctx || document).forEach(function (btn) {
      if (btn.dataset.odWishBound) return;
      btn.dataset.odWishBound = '1';

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var handle = btn.dataset.handle;
        if (!handle) return;

        var added = toggle(handle, btn.dataset.id);

        if (wish.toast && window.OD && window.OD.toast) {
          window.OD.toast(added ? (strings.saved || 'Saved') : (strings.removed || 'Removed'));
        }
      });
    });

    paintButtons(ctx);
  }

  /* ------------------------------------------------------ wishlist page */

  function renderPage(root) {
    if (root.dataset.odWishPageBound) return;
    root.dataset.odWishPageBound = '1';

    var grid = $('[data-od-wish-grid]', root);
    var emptyEl = $('[data-od-wish-empty]', root);
    var countEl = $('[data-od-wish-total]', root);
    var clearBtn = $('[data-od-wish-clear]', root);
    if (!grid) return;

    function draw() {
      var list = read();

      if (countEl) {
        countEl.textContent = list.length + (list.length === 1 ? ' piece' : ' pieces');
      }

      if (!list.length) {
        grid.innerHTML = '';
        if (emptyEl) emptyEl.hidden = false;
        if (clearBtn) clearBtn.hidden = true;
        return;
      }

      if (emptyEl) emptyEl.hidden = true;
      if (clearBtn) clearBtn.hidden = false;
      grid.setAttribute('aria-busy', 'true');

      var rootUrl = (cfg.routes && cfg.routes.root) || '/';
      if (rootUrl === '/') rootUrl = '';

      Promise.all(list.map(function (item) {
        return fetch(rootUrl + '/products/' + encodeURIComponent(item.handle) + '?section_id=od-card-fragment')
          .then(function (r) { return r.ok ? r.text() : ''; })
          .catch(function () { return ''; })
          .then(function (html) { return { handle: item.handle, html: html }; });
      })).then(function (parts) {
        var frag = document.createDocumentFragment();
        var gone = [];

        parts.forEach(function (part) {
          if (!part.html) { gone.push(part.handle); return; }
          var doc = new DOMParser().parseFromString(part.html, 'text/html');
          var card = doc.querySelector('[data-od-card]');
          if (!card) { gone.push(part.handle); return; }

          // a remove control specific to the wishlist page
          var media = card.querySelector('.od-card__media');
          if (media) {
            var kill = document.createElement('button');
            kill.type = 'button';
            kill.className = 'od-card__remove';
            kill.setAttribute('aria-label', 'Remove from ' + (strings.saved || 'saved'));
            kill.innerHTML = '<span class="od-chip__x" aria-hidden="true"></span>';
            kill.addEventListener('click', function (ev) {
              ev.preventDefault();
              remove(part.handle);
              draw();
            });
            media.appendChild(kill);
          }

          frag.appendChild(card);
        });

        // products that have been deleted or unpublished drop off the list
        if (gone.length) {
          write(read().filter(function (x) { return gone.indexOf(x.handle) === -1; }));
        }

        grid.innerHTML = '';
        grid.appendChild(frag);
        grid.removeAttribute('aria-busy');

        if (window.OD && window.OD.refresh) window.OD.refresh(grid);
        bind(grid);

        if (!grid.children.length && emptyEl) emptyEl.hidden = false;
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        write([]);
        draw();
      });
    }

    document.addEventListener('od:wishlist:changed', function () {
      // only redraw when something was removed elsewhere on the page
      var cards = $$('[data-od-card]', grid).length;
      if (cards !== read().length) draw();
    });

    draw();
  }

  /* --------------------------------------------------------------- init */

  function init(ctx) {
    if (wish.enabled === false) return;
    bind(ctx);
    $$('[data-od-wish-page]', ctx || document).forEach(renderPage);
  }

  function boot() {
    try {
      init(document);
      paintCount(read().length);
    } catch (e) {
      if (window.console && console.warn) console.warn('[OD wishlist]', e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  // keep tabs in step
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) broadcast(read());
  });

  window.OD = window.OD || {};
  window.OD.wishlist = {
    read: read,
    has: has,
    toggle: toggle,
    remove: remove,
    clear: function () { write([]); }
  };
  window.OD.initWishlist = init;
})();
